import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import dateFormat from "dateformat";
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import { hours_list } from "../../Shared/List"

const UpdateMotorReportForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [motorOptions, setMotorOptions] = useState([{id: "", name: '-- Please choose motor --', key: null}])
    const [hourOptions, setHourOptions] = useState([{id: "", name: '-- Please choose hour --', key: null}])

    const [formData, setFormData] = useState({
        hour: "",
        motor_id: "",
        previous_reading: 0,
        current_reading: 0,
        difference: 0,
        fuel: 0,
        public_id: "",
        date: "",
    })
    const {hour, motor_id, previous_reading, current_reading, difference, fuel, public_id, date} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {data} = location.state
            
            // format report-date to march date input date format
            const date = dateFormat(new Date(data.date), "yyyy-mm-dd");
            
            setFormData((prev) => ({
                ...prev,
                motor_id: data.motor_id,
                previous_reading: parseInt(data.previous_reading),
                current_reading: parseInt(data.current_reading),
                difference: parseInt(data.difference),
                fuel: parseInt(data.fuel),
                hour: parseInt(data.hour),
                public_id: data.public_id,
                date: date,
            }))
        }

        let isMounted = true
        const getMotors = async () => {
            setIsLoading(true)
            try {
                const motors_response = await Server.get('/motors/')
                if(isMounted){
                    
                    const motors = motorOptions
                    const hours = hourOptions                 
                    motors_response.data.map(motor => (
                        motors.push({
                            id: motor.id,
                            public: motor.public_id,
                            name: motor.name
                        })
                    ))

                    hours_list.map(hour => (
                        hours.push({
                            id: hour.id,
                            name: hour.name,
                            key: hour.key,
                        })
                    ))
                    setHourOptions(hours)
                    setMotorOptions(motors)

                }
                setIsLoading(false) 
            } catch (error) {
                setIsLoading(false)
                setMotorOptions([])
            }
        }
        
        getMotors()
        return () => (isMounted = false);
    }, [])

    const onKeyUp = (e) => {
        setTimeout(() => {
            if (parseFloat(e.target.value) < previous_reading){
                setFormData((prevState) => ({
                    ...prevState,
                    current_reading: 0,
                    difference: 0,
                }))
            }else{
                setFormData((prevState) => ({
                    ...prevState,
                    difference: current_reading - previous_reading,
                }))
            }
        }, 500)
    }
    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {motor_id, previous_reading, current_reading, difference, fuel, date, hour}
        updateReport(payload)
    }
    
    // update report
    const updateReport = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.put(`/motor-reports/${public_id}`, payload)
            if (response.status === 200){
                toast.success('Successfully updated')
                navigate('/motor-daily-reports')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header bg-info p-2 justify-content-center">
                <h3 className="card-title">Update Motor Report Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="hour"
                                label="Hour"
                                value={parseInt(hour)}
                                options={hourOptions}
                                onChange={onChange}
                                error={errors.hour}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="motor_id"
                                label="Motor"
                                value={parseInt(motor_id)}
                                options={motorOptions}
                                onChange={onChange}
                                error={errors.motor_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Previous Reading"
                                name="previous_reading"
                                type="number"
                                disabled="disabled"
                                label="Previous Reading"
                                value={parseInt(previous_reading)}
                                onChange={onChange}
                                error={errors.previous_reading}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Current Reading"
                                name="current_reading"
                                type="number"
                                label="Current Reading"
                                value={parseInt(current_reading)}
                                onKeyUp={onKeyUp}
                                onChange={onChange}
                                error={errors.current_reading}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Difference"
                                name="difference"
                                type="number"
                                disabled="disabled"
                                label="Difference"
                                value={parseInt(difference)}
                                onChange={onChange}
                                error={errors.difference}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Fuel"
                                name="fuel"
                                type="number"
                                label="Fuel"
                                value={parseInt(fuel)}
                                onChange={onChange}
                                error={errors.fuel}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Report" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateMotorReportForm
